/* eslint-disable */
export const CHANGE_CHART_INDICATOR = 'CHANGE_CHART_INDICATOR'
export const IS_DATA_LOADING = 'IS_DATA_LOADING'

export const setDataIsLoading = data => dispatch => dispatch({ type: IS_DATA_LOADING, ...data })

export const setChartIndicator = curInd => dispatch =>
  dispatch({ type: CHANGE_CHART_INDICATOR, curInd })
